export default __webpack_public_path__ + "static/media/1_6.9f3e7be9.png";